import { render, staticRenderFns } from "./SuggestedTransactionModal.vue?vue&type=template&id=36edf040&scoped=true"
import script from "./SuggestedTransactionModal.vue?vue&type=script&lang=ts"
export * from "./SuggestedTransactionModal.vue?vue&type=script&lang=ts"
import style0 from "./SuggestedTransactionModal.vue?vue&type=style&index=0&id=36edf040&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36edf040",
  null
  
)

export default component.exports